import { c as _c } from "react/compiler-runtime";
import { isNotNil } from '@newfront-insurance/core';
import { useCallback } from 'react';
import { useEmployeesByUserUuid } from './use-employees-by-user-uuid';
import type { NormalizedAccountEmployeeRoleMappings, Employee } from '../../bff/types';
interface WithEmployeeRoleMappings {
  employeeRoleMappings: NormalizedAccountEmployeeRoleMappings;
}
interface ServicingTeamForAccountHook {
  getServicingTeamForAccount: (withEmployeeRoleMappings: WithEmployeeRoleMappings) => Employee[];
}
export function useServicingTeamForAccount() {
  const $ = _c(6);
  const {
    accountManagersMap,
    producersMap,
    operationsEmployeesMap
  } = useEmployeesByUserUuid();
  let t0;
  if ($[0] !== accountManagersMap || $[1] !== operationsEmployeesMap || $[2] !== producersMap) {
    t0 = withEmployeeRoleMappings => {
      const {
        employeeRoleMappings
      } = withEmployeeRoleMappings;
      const accountManagers = [...(employeeRoleMappings.PRIMARY_ACCOUNT_MANAGER || []), ...(employeeRoleMappings.SECONDARY_ACCOUNT_MANAGER || [])].map(roleMapping => accountManagersMap.get(roleMapping.userUuid));
      const producers = [...(employeeRoleMappings.PRIMARY_PRODUCER || []), ...(employeeRoleMappings.SECONDARY_PRODUCER || [])].map(roleMapping_0 => producersMap.get(roleMapping_0.userUuid));
      const clientServiceAssociates = [...(employeeRoleMappings.CSA || [])].map(roleMapping_1 => operationsEmployeesMap.get(roleMapping_1.userUuid));
      return [...accountManagers, ...producers, ...clientServiceAssociates].filter(isNotNil);
    };
    $[0] = accountManagersMap;
    $[1] = operationsEmployeesMap;
    $[2] = producersMap;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const getServicingTeamForAccount = t0;
  let t1;
  if ($[4] !== getServicingTeamForAccount) {
    t1 = {
      getServicingTeamForAccount
    };
    $[4] = getServicingTeamForAccount;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}